import { gql } from '@apollo/client';

export const REQUEST_SUBSIDY = gql`
  mutation RequestSubsidy($input: RequestSubsidyInput!) {
    requestSubsidy(input: $input) {
      subsidyRequestId
      oem
      customer
      dealer
      lender
      term
      financeAmount
      subsidyPercentage
      dnetPercentage
      dnet
      approvedSubsidyAmount
      dealerParticipationPercentage
      dealerContribution
      oemContribution
      equipment {
        id
        year
        make
        model
        serialNumberVin
      }
    }
  }
`;
